import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baoming",
  "use": "icon-baoming-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" stroke=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-baoming\"><rect x=\"6\" y=\"6\" width=\"36\" height=\"36\" rx=\"3\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M32 30H36\" stroke-width=\"4\" stroke-linecap=\"round\" /><path d=\"M24 24H36\" stroke-width=\"4\" stroke-linecap=\"round\" /><path d=\"M28 18H36\" stroke-width=\"4\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol